<template>
  <div class="loader-outer-wrapper">
    <div class="loader-wrapper" :class="[colour]">
      <div class="spinner spinner-1"></div>
      <div class="spinner spinner-2"></div>
      <div class="spinner spinner-3"></div>
      <div class="spinner spinner-4"></div>
      <div class="spinner spinner-5"></div>
      <div class="spinner spinner-6"></div>
      <div class="spinner spinner-7"></div>
    </div>
    <div>
      <transition name="fade" mode="out-in">
        <span :key="reckonerSentence">{{ reckonerSentence }}</span>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      colour: {
        type: String,
        default: '',
      },
      reckoner: {
        type: String,
        default: '',
      },
      reckonerData: Object,
    },
    data() {
      return {
        oReckonerContent: {},
        iReckonerId: 0,
      };
    },
    mounted() {
      this.oReckonerContent = {
        'story': [ "Reticulating splines...", "Just a moment...", "Generating summary...", "Analyzing ${topic_0} and ${topic_1}...", "Gathering insights...", "Syncing with ${publisher}...", "Compiling news...", "Rewriting for balance...", "Processing updates...", "Reviewing ${publisher}'s take...", "Checking sources...", "Verifying information...", "Updating story...", "Loading new perspectives...", "Balancing viewpoints...", "Fine-tuning details...", "Curating content...", "Optimizing summary...", "Reticulating new data...", "Integrating ${publisher}'s view...", "Reading up on ${topic_0}...", "Syncing with ${publisher}'s article...", "Revisiting ${topic_1}...", "Enhancing summary...", "Merging viewpoints...", "Reviewing new info...", "Analyzing new article...", "Compiling perspectives...", "Gathering ${publisher}'s insights...", "Synthesizing information...", "Loading balanced view...", "Just reading up on ${topic_0} and ${topic_1}...", "Checking what ${publisher} has said on the subject...", "Reticulating latest data...", "Adjusting summary...", "Updating with new article...", "Balancing news content...", "Processing ${publisher}'s take...", "Verifying with ${topic_0}...", "Reviewing ${publisher}'s perspective...", "Summarizing updates...", "Curating balanced news...", "Enhancing article...", "Reticulating ${topic_0} and ${topic_1}...", "Gathering diverse views...", "Loading comprehensive summary...", "Reading ${publisher}'s insights...", "Integrating balanced perspective...", "Analyzing ${publisher}'s contribution...", "Syncing with latest data...", "Checking ${topic_1} details...", "Curating latest updates...", "Balancing new perspectives...", "Processing ${topic_0} insights...", "Compiling balanced news...", "Reading ${publisher}'s view...", "Summarizing ${publisher}'s article...", "Reticulating ${topic_0} insights...", "Checking ${topic_0} and ${topic_1}...", "Updating ${topic_1} details...", "Processing ${publisher}'s news...", "Compiling ${topic_0} data...", "Reviewing ${topic_1} updates...", "Integrating ${publisher}'s news...", "Loading ${topic_0} analysis...", "Balancing ${publisher}'s take...", "Reading up on ${topic_0}...", "Synthesizing ${topic_0} and ${topic_1}...", "Curating ${publisher}'s article...", "Optimizing ${topic_1} view...", "Gathering ${publisher}'s data...", "Analyzing ${topic_0} details...", "Reviewing ${publisher}'s insights...", "Updating with ${publisher}'s take...", "Compiling ${topic_0} and ${topic_1}...", "Balancing ${topic_1} perspectives...", "Summarizing ${topic_0} and ${topic_1}...", "Reticulating ${publisher}'s data...", "Integrating ${topic_0}...", "Verifying ${topic_1} data...", "Curating ${publisher}'s perspective...", "Loading ${topic_1} analysis...", "Balancing ${topic_0} insights...", "Processing ${topic_0} and ${topic_1}...", "Reading ${topic_1} updates...", "Synthesizing ${publisher}'s perspective...", "Checking ${publisher}'s article...", "Reviewing ${topic_0} and ${topic_1}...", "Summarizing ${topic_0}...", "Optimizing ${topic_0} and ${topic_1}...", "Compiling ${publisher}'s take...", "Gathering ${topic_0} perspectives...", "Analyzing ${topic_1} updates...", "Updating ${topic_0} details...", "Verifying ${publisher}'s data...", "Curating ${topic_1} news...", "Reticulating ${topic_1} and ${publisher}'s data..."]
          .sort(() => (Math.random() > 0.5) ? -1 : 1),
      },
      window.setInterval(() => {
        this.iReckonerId ++;
      }, 4500);
    },
    computed: {
      hasReckoner() {
        return !!this.reckoner;
      },
      reckonerSentence() {
        return this.getReckonerSentence();
      }
    },
    methods: {
      updateReckonerId() {
        this.iReckonerId ++;
      },
      getReckonerSentence() {
        // eslint-disable-next-line
        let sSentence = this.oReckonerContent[this.reckoner]?.[this.iReckonerId];
        // eslint-disable-next-line
        let topic_0 = this.reckonerData?.topic?.[0] || 'opinions'; 
        // eslint-disable-next-line
        let topic_1 = this.reckonerData?.topic?.[1] || 'other factors';
        // eslint-disable-next-line
        let publisher = this.reckonerData?.publisher?.[0] || 'sources';

        return sSentence ? eval("`" + sSentence + "`") : '';
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';

  .loader-outer-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    /* align-content: center; */
    justify-content: space-around;
    align-items: center;
  }

  .loader-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    height: 75px;
    animation: rotation .3s ease-in-out infinite;
  }

  $transparency: 0.6;

  .spinner {
    position: absolute;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    // border-style: double !important; // < have fun! :o) https://developer.mozilla.org/en-US/docs/Web/CSS/border-style
    animation: rotation .3s ease-in-out infinite;
    border: 3px solid rgba($base-background, 0);
    border-top-color: rgba($yellow-tone-3, $transparency * 1.0 );
    .green & {
      border-top-color: rgba($green-tone-3, $transparency * 1.0 );
    }
    &.spinner-1 {
      animation: rotation-a .3s ease-in-out infinite;
      animation-delay: .1s;
      border-top-color: rgba($yellow-tone-3, $transparency * 1.5 );
      .green & {
        border-top-color: rgba($green-tone-3, $transparency * 1.5 );
      }
    }
    &.spinner-2 {
      animation: rotation-a .4s ease-in-out infinite;
      animation-delay: .2.1s;
      border-top-color: rgba($yellow-tone-3, $transparency * 1.3 );
      .green & {
        border-top-color: rgba($green-tone-3, $transparency * 1.3 );
      }
    }
    &.spinner-3 {
      animation: rotation-b .5s ease-in-out infinite;
      animation-delay: .3s;
      border-top-color: rgba($yellow-tone-3, $transparency * 0.8);
      .green & {
        border-top-color: rgba($green-tone-3, $transparency * 0.8 );
      }
    }
    &.spinner-4 {
      animation: rotation-b .7s ease-in-out infinite;
      animation-delay: .1s;
      animation-direction: alternate;
      width: 1.5rem;
      height: 1.5rem;
      border-top-color: rgba($orange-tone-3, $transparency * 1.2 );
      .green & {
        border-top-color: rgba($green-tone-3, $transparency * 1.2 );
      }
      transform: rotate(45deg);
    }
    &.spinner-5 {
      animation: rotation-d 1.1s ease-in-out infinite;
      animation-delay: .4.2s;
      // animation-direction: alternate;
      width: 1.5rem;
      height: 1.5rem;
      border-top-color: rgba($orange-tone-3, $transparency * 1.1 );
      .green & {
        border-top-color: rgba($green-tone-2, $transparency * 1.1 );
      }
      transform: rotate(-40deg);
    }
    &.spinner-6 {
      animation: rotation-e 0.9s ease-in-out infinite;
      animation-delay: .2.4s;
      animation-direction: alternate;
      width: 1rem;
      height: 1rem;
      border-top-color: rgba($red-tone-3, $transparency * 0.9 );
      .green & {
        border-top-color: rgba($green-tone-1, $transparency * 0.9 );
      }
      transform: rotate(128deg);
    }
    &.spinner-7 {
      animation: rotation-f 0.8s ease-in-out infinite;
      animation-delay: .5.4s;
      // animation-direction: alternate;
      width: 1rem;
      height: 1rem;
      border-top-color: rgba($red-tone-3, $transparency * 1.4 );
      .green & {
        border-top-color: rgba($green-tone-1, $transparency * 1.4 );
      }
      transform: rotate(256deg);
    }
  }
    
  @keyframes rotation-a {
      from {transform: rotate(0deg);}
      to {transform: rotate(360deg);}
  }
  @keyframes rotation-b {
      from {transform: rotate(90deg);}
      to {transform: rotate(450deg);}
  }
  @keyframes rotation-c {
      from {transform: rotate(-20deg);}
      to {transform: rotate(340deg);}
  }
  @keyframes rotation-d {
      from {transform: rotate(-45deg);}
      to {transform: rotate(300deg);}
  }
  @keyframes rotation-e {
      from {transform: rotate(20deg);}
      to {transform: rotate(320deg);}
  }
  @keyframes rotation-f {
      from {transform: rotate(-90deg);}
      to {transform: rotate(270deg);}
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>